const ptBR = {
  // ── Configuração de moeda / locale
  currency: {
    symbol: 'R$',
    code: 'BRL',
    locale: 'pt-BR',
  },

  // ── Navbar
  nav: {
    home: 'Home',
    chaos: 'Caos na Portaria',
    howItWorks: 'Como funciona',
    product: 'Produto',
    modules: 'Módulos',
    plans: 'Planos',
    faq: 'Dúvidas',
    login: 'Entrar',
    trialBtn: 'Teste grátis',
  },

  // ── Hero slides
  hero: {
    slides: [
      {
        badge: '📱 WhatsApp + CondoClick = Condomínio Inteligente',
        h2Line1: 'Transforme o WhatsApp',
        h2Line2: 'do condomínio em uma',
        h2Accent: 'condomínio inteligente',
        p: 'Aviso de encomenda, controle de portaria, entrada de veículos, reserva de áreas, livro de ocorrências e comunicados — tudo pelo WhatsApp.',
      },
      {
        badge: 'Encomendas Digitais — sem papel, sem perda',
        h2Line1: 'Da portaria ao morador,',
        h2Line2: 'cada entrega rastreada,',
        h2Accent: 'zero pacote perdido',
        p: 'Porteiro fotografa e registra. Morador recebe aviso no WhatsApp com foto. Retirada confirmada por QR Code. Tudo rastreado, sem papel, sem ligação.',
      },
      {
        badge: 'Gestão de Portaria — tudo no controle',
        h2Line1: 'Aqui no condomínio ninguém perde encomenda.',
        h2Line2: '',
        h2Accent: 'Tudo fica registrado',
        p: 'Equipe alinhada, síndico informado e moradores satisfeitos. Relatórios completos e transparência total sem nenhum papel.',
      },
      {
        badge: 'Entrada de Veículo — acesso inteligente',
        h2Line1: 'Registre placas, autorize',
        h2Line2: 'visitantes pelo painel,',
        h2Accent: 'sem fila na portaria',
        p: 'Cadastro de visitantes e autorização pelo painel web — sem baixar nada. Portaria mais ágil, segurança reforçada e histórico completo de todas as entradas.',
      },
      {
        badge: '😅 Sem CondoClick — a portaria vira caos',
        h2Line1: 'Planilha, caderno,',
        h2Line2: 'WhatsApp e gritaria…',
        h2Accent: 'tem jeito melhor! 🚀',
        p: 'Síndico, a gente sabe: sem sistema, o controle de acesso vira bagunça. Visitante sem autorização, morador ligando pra portaria às 23h e planilha desatualizada. Com o CondoClick, isso é passado.',
      },
    ],
    cta: 'Assinar agora — a partir de {{symbol}} 59/mês',
    trustNoFidelity: 'Sem fidelidade',
    trustCancel: 'Cancele quando quiser',
    trustSupport: 'Suporte incluído',
  },

  // ── Social proof bar
  stats: {
    condos: 'condomínios ativos',
    syndics: 'síndicos satisfeitos',
    setup: 'tempo de configuração',
  },

  // ── Seção DORES
  pain: {
    sectionBadge: 'Realidade de 89% das portarias brasileiras',
    title: 'A portaria virou o problema',
    titleAccent: 'mais difícil do condomínio',
    subtitle: 'Porteiro sobrecarregado, morador irritado, síndico apagando incêndio — e ao final do dia não há registro de nada. E como se não bastasse, a LGPD chegou: cadernos, planilhas e softwares ultrapassados não protegem os dados de ninguém. Quem não se adequar responde com multa de até R$ 50 milhões — e ainda expõe cada morador.',
    stats: [
      { n: '340h', label: 'por ano perdidas em ligações desnecessárias (por porteiro)' },
      { n: '25%', label: 'das encomendas ficam paradas por mais de 7 dias sem retirar' },
      { n: '73%', label: 'dos conflitos em condomínios têm início na portaria' },
      { n: 'R$0', label: 'de rastro ou prova quando algo dá errado' },
    ],
    detailTitle: 'As 7 grandes dores',
    detailSubtitle: 'Cada dia na portaria é uma nova batalha',
    detailDesc: 'Mapeamos os problemas mais frequentes relatados por porteiros, síndicos e moradores em centenas de condomínios brasileiros.',
    voices: {
      sectionLabel: 'Quem vive isso todo dia',
      title: 'A voz de quem está na portaria',
      subtitle: 'Relatos reais coletados durante pesquisa com porteiros e síndicos em todo o Brasil.',
      items: [
        {
          quote: 'Vivo no telefone. Enquanto falo com um morador que quer saber se chegou encomenda, outro visitante entra sem eu nem ver quem é. É impossível fazer tudo ao mesmo tempo.',
          name: 'Carlos A.',
          role: 'Porteiro — 11 anos de profissão, SP',
        },
        {
          quote: 'Já perdi conta de quantas vezes tive que mediar briga de morador por causa de encomenda sumida. Nenhum registro, nenhuma foto. O porteiro jura que guardou, o morador jura que não. Impossível resolver.',
          name: 'Márcia S.',
          role: 'Síndica há 4 anos, condomínio de 180 aptos, RJ',
        },
        {
          quote: 'Cheguei da viagem e minha encomenda tinha sumido. O porteiro mostrou o caderno — uma letra impossível, data errada. Ficou assim: sem encomenda, sem culpado, sem solução.',
          name: 'Rodrigo M.',
          role: 'Morador, apartamento 83, São Paulo',
        },
      ],
    },
    costSection: {
      badge: 'O custo que ninguém calcula',
      title: 'Quanto a portaria desorganizada custa por ano?',
      subtitle: 'Não é só o estresse. Há custos financeiros, jurídicos e de rotatividade que são ignorados até virarem um problema maior.',
      items: [
        { value: 'R$ 2.400', label: 'perdidos por ano com retrabalho e ligações desnecessárias (estimativa por porteiro)' },
        { value: 'R$ 800+', label: 'em média por ocorrência de extravio de encomenda com processo ou acordo' },
        { value: '43%', label: 'de turnover maior em portarias que não têm sistema de apoio ao porteiro' },
        { value: '18h', label: 'por mês que o síndico gasta resolvendo conflitos que um sistema evitaria' },
      ],
      timeline: {
        label: 'Um dia típico na portaria sem sistema',
        events: [
          { time: '07h00', event: 'Plantão começa. 3 encomendas no chão sem identificação da semana anterior.' },
          { time: '08h30', event: 'Morador liga perguntando se chegou encomenda. Porteiro procura no caderno por 5 minutos.' },
          { time: '09h15', event: 'Transportadora chega para mudança sem agendamento. Elevador travado.' },
          { time: '10h00', event: 'Visitante insiste em entrar sem autorização. Porteiro liga pro morador — cai na caixa postal.' },
          { time: '11h45', event: 'Moradora furiosa reclama que encomenda sumiu. Nenhum registro, nenhuma foto.' },
          { time: '14h00', event: 'Síndico chega para apagar incêndio. Passa 2h resolvendo o que não é função dele.' },
          { time: '18h00', event: 'Plantão encerrado. Nenhum registro formal do dia. Amanhã começa tudo de novo.' },
        ],
      },
    },
    solution: {
      badge: 'A boa notícia',
      title: 'Todos esses problemas têm solução.',
      titleAccent: 'E mais simples do que parece.',
      subtitle: 'O CondoClick foi criado depois de entrevistar dezenas de porteiros e síndicos. Cada funcionalidade resolve uma dor real — não é recurso de fachada.',
      ctaSee: 'Ver como funciona',
      ctaPlan: 'Teste grátis',
    },
    cards: [
      {
        emoji: '📦',
        title: 'Encomendas sem controle',
        badge: 'Criticidade ALTA',
        desc: 'A portaria virou depósito. Caixas espalhadas pelo chão, sem identificação, sem foto, sem registro de quando chegou. O morador liga furioso — o porteiro não sabe de nada. Quando encontra, já estava lá há duas semanas. Se sumiu, não tem prova de nada.',
        items: [
          { emoji: '😤', text: 'Morador liga repetidamente para saber se chegou' },
          { emoji: '🗂️', text: 'Caderno rasurado, ilegível ou simplesmente sumiu' },
          { emoji: '😰', text: 'Nenhuma foto = nenhuma prova em caso de extravio' },
        ],
      },
      {
        emoji: '📞',
        title: 'Porteiro: central de ligações',
        badge: 'Criticidade ALTA',
        desc: '"Chegou encomenda. Chegou visita. Já posso subir? Seu carro tá bloqueando." O porteiro passa boa parte do plantão no telefone — em vez de cuidar da segurança. Enquanto isso, quem controla quem entra?',
        items: [
          { emoji: '📲', text: 'Média de 60 a 120 ligações por plantão em condos médios' },
          { emoji: '🚪', text: 'Controle de acesso comprometido nas horas de pico' },
          { emoji: '😵', text: 'Porteiro esgotado = mais erros e menos atenção' },
        ],
      },
      {
        emoji: '🚗',
        title: 'Acesso veicular sem registro',
        badge: 'Risco de SEGURANÇA',
        desc: 'Uber, iFood, prestador de serviço, visitante — tudo liberado na base da palavra. Não há registro da placa, do horário, de qual unidade foi. E se acontece algo, não tem como saber quem entrou. A segurança do condomínio depende de memória.',
        items: [
          { emoji: '❓', text: 'Quem entrou ontem às 22h? Impossível saber' },
          { emoji: '🔓', text: 'Prestadores entram e saem sem rastro nenhum' },
          { emoji: '📝', text: 'Livro de ocorrências ilegível e incompleto' },
        ],
      },
      {
        emoji: '📅',
        title: 'Salão reservado duas vezes',
        badge: 'Conflito recorrente',
        desc: 'Dois moradores reservaram o mesmo dia no salão. Um pelo grupo do WhatsApp, outro "avisou o porteiro". Resultado: briga, reunião de condomínio, síndico mediando conflito numa sexta à noite. Isso se repete todo mês em algum espaço do prédio.',
        items: [
          { emoji: '😡', text: 'Conflitos entre moradores por dupla reserva' },
          { emoji: '💬', text: 'Reservas feitas por grupo de WhatsApp sem controle' },
          { emoji: '🤦', text: 'Síndico gasta horas mediando o que seria evitável' },
        ],
      },
      {
        emoji: '🚛',
        title: 'Mudança travando o elevador às 7h',
        badge: 'Portaria',
        desc: 'A transportadora chegou cedo, sem aviso, e tomou o elevador social de manhã. Nenhum outro morador consegue usar. O porteiro não sabe o que fazer. O síndico precisa ser acionado de urgência — em sábado de folga.',
        items: [
          { emoji: '🛗', text: 'Elevador bloqueado por horas sem agendamento' },
          { emoji: '📵', text: 'Síndico acionado no celular pessoal no fim de semana' },
          { emoji: '🏗️', text: 'Sem registro de condição do elevador antes/depois' },
        ],
      },
      {
        emoji: '📢',
        title: 'Comunicados que ninguém lê',
        badge: 'Comunicação',
        desc: 'O aviso de manutenção foi colado no elevador na segunda. Na quarta, metade dos moradores ainda reclamou que não sabia. O papel sumiu, o grupo do WhatsApp está mudo, e ninguém confirma que recebeu. Como provar que comunicou?',
        items: [
          { emoji: '🗒️', text: 'Avisos em papel que desaparecem ou ficam rasgados' },
          { emoji: '🔕', text: 'Grupo do WhatsApp com 200 mensagens não lidas' },
          { emoji: '📋', text: 'Sem confirmação de leitura = sem prova jurídica' },
        ],
      },
      {
        emoji: '🔑',
        title: 'Síndico sem visibilidade do que acontece',
        badge: 'Gestão',
        desc: 'O síndico só fica sabendo dos problemas quando já viraram conflito. Não há dados, não há relatório, não há histórico. Cada decisão é tomada no chute. Assembleia chegando e não tem nada concreto para apresentar.',
        items: [
          { emoji: '📊', text: 'Nenhum dado para embasar decisões de gestão' },
          { emoji: '🕵️', text: 'Só descobre o problema quando já virou crise' },
          { emoji: '📑', text: 'Assembleia sem relatório = síndico sem credibilidade' },
        ],
      },
    ],
  },

  // ── Para quem
  forWhom: {
    badge: 'Para quem é o CondoClick?',
    title: 'Cada um tem o que precisa. No mesmo sistema.',
    subtitle: 'Quem registra, quem autoriza, quem acompanha e quem recebe — todos conectados pelo WhatsApp, sem instalar nada.',
    profiles: [
      {
        role: 'Morador',
        title: 'Encomenda chegou. Você já sabe.',
        desc: 'Sem ligar pra portaria, sem ficar esperando no corredor. Assim que a encomenda chega, você recebe a foto direto no WhatsApp. Na hora de retirar, é só mostrar o QR Code. Visita chegando? Você autoriza pelo celular, sem sair do trabalho.',
      },
      {
        role: 'Porteiro',
        title: 'Menos ligação. Mais controle.',
        desc: 'Chega de anotar em caderno, atender telefone de morador querendo saber de encomenda e liberar visitante no "olhômetro". Com o CondoClick, tudo é registrado em segundos pelo celular — foto, unidade, QR Code — e o sistema avisa o morador sozinho.',
      },
      {
        role: 'Síndico',
        title: 'Você sabe o que acontece. Mesmo de longe.',
        desc: 'Fim de semana, viagem, reunião — não importa onde você esteja. O painel mostra em tempo real tudo que passa pela portaria. Sem ligar pro porteiro, sem esperar relatório na segunda-feira, sem ser surpreendido por problemas que já viraram crise.',
      },
      {
        role: 'Administradora',
        title: 'Muitos condomínios, zero confusão.',
        desc: 'Cada condomínio no seu ambiente, com dados isolados e acesso pelo link exclusivo. Sem abrir mil abas, sem misturar informação, sem depender de planilha. Você acompanha tudo de um único lugar — e responde com dados, não com achismo.',
      },
    ],
  },

  // ── Produto / Showcase
  product: {
    badge: 'Veja o produto',
    title: 'Um sistema para cada perfil',
    subtitle: 'Do porteiro ao morador — todo mundo ganha com o CondoClick.',
    tabs: {
      porteiro: '👮 Porteiro',
      morador: '🏠 Morador',
      sindico: '📊 Síndico',
      entregador: '📦 Entregador',
    },
    porteiro: {
      title: 'Registrar encomenda em 30 segundos',
      desc: 'O porteiro abre o painel no celular, fotografa a encomenda, seleciona a unidade e clica em registrar. O WhatsApp do morador recebe a notificação na mesma hora.',
      features: ['Foto automática da encomenda', 'Busca rápida por unidade ou nome', 'QR Code gerado na hora', 'WhatsApp enviado automaticamente'],
    },
    morador: {
      title: 'Morador avisado na hora certa',
      desc: 'Assim que o porteiro registra, o morador recebe um WhatsApp com foto, detalhes e um QR Code exclusivo. Na hora de retirar, basta mostrar o código na portaria.',
      features: ['Notificação instantânea no WhatsApp', 'Foto da encomenda na mensagem', 'QR Code para retirada rápida', 'Histórico de todas as entregas'],
    },
    entregador: {
      badge: 'Novo — Auto-registro por QR Code',
      title: 'Entregador registra sozinho, sem porteiro',
      desc1: 'Coloque um QR Code fixo no vidro da portaria ou em uma plaquinha na entrada. O entregador da Shopee, iFood, Correios ou qualquer transportadora escaneia com o próprio celular, tira a foto e registra a entrega — tudo sem precisar chamar o porteiro.',
      desc2: 'O morador recebe a notificação no WhatsApp na mesma hora. Portaria mais ágil, fila zero e nenhuma encomenda esquecida na calçada.',
      features: [
        'QR Code fixo colado no vidro ou plaquinha',
        'Entregador escaneia com qualquer celular',
        'Tira foto e informa o volume',
        'Morador recebe WhatsApp instantâneo',
        'Zero dependência do porteiro',
        'O QR Code da portaria funciona mesmo sem internet',
      ],
      plaqueLabel: 'Registre sua entrega aqui',
      plaqueSub: 'Escaneie com qualquer celular',
      plaqueStickerLabel: 'Plaquinha impressa ou adesivo no vidro da portaria',
    },
    sindico: {
      title: 'Síndico sempre no controle',
      desc: 'Dashboard com relatórios, histórico completo de entregas, gestão de moradores e status em tempo real de tudo que passa pela portaria.',
      features: ['Dashboard com métricas em tempo real', 'Relatórios mensais automáticos', 'Gestão de moradores e unidades', 'Auditoria completa de todas as entregas'],
    },
  },

  // ── Módulos
  modules: {
    badge: 'Módulos',
    title: 'Um sistema, seis módulos',
    subtitle: 'Ative os que precisa. Cada módulo funciona de forma independente e se integra aos demais.',
    prevBtn: 'Anterior',
    nextBtn: 'Próximo',
    activeLabel: 'Ativo agora',
    qrLabel: 'QR Code gerado',
    qrSub: 'Tudo funciona offline',
    crosscutting: [
      { title: 'Tudo por QR Code', description: 'QR Codes únicos por evento — visita, encomenda, reserva ou mudança.' },
      { title: 'WhatsApp nativo', description: 'Notificações automáticas pelo WhatsApp, sem instalar nada.' },
      { title: '100% Mobile', description: 'Porteiro, morador e síndico acessam pelo celular, no navegador.' },
      { title: 'Relatórios ao vivo', description: 'Dashboard e relatórios completos para o síndico sempre no controle.' },
    ],
    list: [
      {
        badge: 'Módulo Encomenda', title: 'Encomendas & Entregas',
        desc: 'Registre pelo painel ou pelo WhatsApp da portaria. O sistema avisa o morador na hora — com foto e QR Code para retirada. Múltiplas encomendas? Um QR só cobre todas.',
        features: [
          'Registro pelo painel ou WhatsApp da portaria',
          'QR Code único por morador — cobre todas as encomendas de uma vez',
          'Notificação automática no WhatsApp na chegada e na retirada',
          'Modo privado: só o destinatário pode retirar',
          'Pré-agendadas: morador avisa antes, você confirma quando chegar',
          'Saídas: morador quer enviar algo, transportadora recebe o código',
          'Abas: Entrada · Pré-agendadas · Saídas · Entregues',
        ],
      },
      {
        badge: 'Módulo Visitas', title: 'Gestão de Visitantes',
        desc: 'Porteiro registra o visitante, morador autoriza pelo WhatsApp e o visitante recebe QR Code. Acesso liberado sem uma ligação sequer.',
        features: ['Aprovação pelo morador via WhatsApp', 'QR Code enviado ao visitante', 'Porteiro escaneia na entrada', 'Frequência configurável', 'Foto e documento do visitante'],
      },
      {
        badge: 'Módulo Veículos', title: 'Controle Veicular',
        desc: 'Sabe exatamente quem entrou, quando saiu e para qual unidade foi. Uber, delivery, prestadores e visitantes — tudo categorizado.',
        features: ['10 categorias pré-definidas', 'Registro de placa e foto', 'Controle de entrada e saída', 'Dashboard ao vivo para o síndico', 'Histórico completo por unidade'],
      },
      {
        badge: 'Módulo Reservas', title: 'Espaços Comuns',
        desc: 'Chega de planilha e WhatsApp para reservar o salão. Morador reserva pelo celular, confirma com QR Code e o espaço fica bloqueado automaticamente.',
        features: ['Calendário de disponibilidade', 'Reserva direto pelo celular, sem instalar nada', 'QR Code de acesso ao espaço', 'Cancelamento sem burocracia', 'Relatório de uso por espaço'],
      },
      {
        badge: 'Módulo Mudanças', title: 'Agendamento de Mudanças',
        desc: 'Moradores agendam a mudança, o síndico aprova e a transportadora recebe QR Code. Elevador social protegido e mudança registrada do início ao fim.',
        features: ['Agendamento com aprovação do síndico', 'QR Code para a transportadora', 'Controle de horário do elevador', 'Notificação aos demais moradores', 'Registro fotográfico de condição'],
      },
      {
        badge: 'Módulo Comunicados', title: 'Alertas & Comunicados',
        desc: 'Envie comunicados, alertas emergenciais e documentos para todos os moradores pelo WhatsApp — com confirmação de leitura.',
        features: ['Avisos via WhatsApp e painel web', 'Alertas de emergência imediatos', 'Segunda via de boleto e documentos', 'Confirmação de leitura', 'Filtro por unidade ou grupo'],
      },
    ],
  },

  // ── QR Code flows
  qrFlows: {
    badge: 'Como funciona na prática',
    title: 'Simples para quem usa. Poderoso para quem gerencia.',
    subtitle: 'Cada módulo tem um fluxo direto — sem papel, sem ligação, sem retrabalho. Tudo rastreado e confirmado automaticamente.',
    flows: [
      {
        title: 'Encomendas',
        desc: 'Porteiro registra a encomenda com foto em segundos. O morador recebe QR Code pelo WhatsApp e retira sem assinar papel. Histórico completo — quem recebeu, quando e por quem foi retirada.',
        steps: ['Porteiro registra + foto', 'QR Code gerado', 'Morador recebe no WhatsApp', 'Apresenta na portaria', 'Retirada confirmada ✅'],
      },
      {
        title: 'Portaria',
        desc: 'Morador autoriza a visita pelo celular antes de chegar. Visitante recebe QR Code pelo WhatsApp. Porteiro escaneia e libera — sem ligar pro apartamento, sem decisão na pressão, sem papel.',
        steps: ['Morador cadastra a visita', 'Aprova pelo celular', 'Visitante recebe QR', 'Porteiro escaneia', 'Acesso liberado ✅'],
      },
      {
        title: 'Controle de Veículos',
        desc: 'Uber, iFood, Rappi, encanador, mudança — todos registrados em segundos com categoria, foto e placa opcional. Lista em tempo real mostra quem está dentro e há quanto tempo. Histórico de 90 dias.',
        steps: ['Veículo chega', 'Porteiro registra placa + categoria', 'Foto capturada', 'Saída confirmada', 'Histórico registrado ✅'],
      },
      {
        title: 'Reservas de Espaços',
        desc: 'Morador reserva salão de festas, piscina ou churrasqueira pelo celular a qualquer hora. Sistema bloqueia conflitos automaticamente. Síndico aprova em um toque. Confirmação enviada pelo WhatsApp.',
        steps: ['Morador escolhe data', 'Sistema verifica disponibilidade', 'Reserva confirmada', 'Síndico aprova', 'Confirmação no WhatsApp ✅'],
      },
      {
        title: 'Livro de Ocorrências',
        desc: 'Morador registra ocorrências pelo app ou direto pelo WhatsApp — com foto e documentos. Síndico revisa, anota as providências e arquiva. Histórico permanente na nuvem. Fim do caderno rasgado.',
        steps: ['Ocorrência registrada', 'Foto ou documento anexado', 'Síndico notificado', 'Providências anotadas', 'Arquivado ✅'],
      },
      {
        title: 'Comunicados',
        desc: 'Aviso, alerta, emergência ou documento — síndico escolhe o tipo, usa template pronto e envia para o WhatsApp de cada morador individualmente. Com confirmação de leitura por unidade. Sem grupo de WhatsApp.',
        steps: ['Síndico cria o comunicado', 'Seleciona destinatários', 'WhatsApp enviado', 'Leitura confirmada', 'Arquivado ✅'],
      },
      {
        title: 'Botão de Pânico',
        desc: 'Quando a situação não pode esperar, um toque no celular dispara um alerta imediato para o síndico via WhatsApp. Nenhuma ligação, nenhuma demora.',
        steps: ['Porteiro aciona o botão', 'Alerta disparado em < 1s', 'Síndico notificado no WhatsApp', 'Ocorrência registrada automaticamente', 'Situação documentada ✅'],
      },
    ],
    banner: 'Cada ação registrada. Cada evento rastreado.',
    bannerSub: 'Do porteiro ao síndico — todo mundo sabe o que aconteceu, quando e por quem.',
  },

  // ── Tipos de condomínio
  condoTypes: {
    badge: 'Qualquer formato',
    title: 'Serve para o seu condomínio?',
    subtitle: 'Sim — independente do tamanho ou formato. O CondoClick se adapta à estrutura real do seu condomínio, não o contrário.',
    types: [
      { title: 'Condomínio de Casas', desc: 'Ruas, vilas e loteamentos fechados. Cada casa é uma unidade — simples assim.' },
      { title: 'Torre Única', desc: 'Andares e apartamentos configurados exatamente como são numerados no seu prédio.' },
      { title: 'Multi-Torres', desc: 'Torre A, B, C... Grandes empreendimentos com cada torre e suas unidades organizadas e separadas.' },
      { title: 'Prédio Comercial', desc: 'Salas, escritórios e andares comerciais. Controle de acesso, visitantes e encomendas para síndicos de prédios corporativos.' },
    ],
    customTitle: '100% customizável',
    customDesc: 'Na primeira vez que você acessa, um assistente guiado configura a estrutura completa do seu condomínio — torres, andares e unidades — exatamente do jeito que ela existe. Sem formulários complicados, sem planilha pra importar.',
  },

  // ── Como funciona
  howItWorks: {
    badge: 'Passo a passo',
    title: 'Comece em 4 etapas simples',
    subtitle: 'Do cadastro à primeira entrega registrada em menos de 2 minutos.',
    steps: [
      { title: 'Ativação', description: 'Escolha o plano ideal e comece a usar logo após o pagamento.' },
      { title: 'Configuração Rápida', description: 'Cadastre as torres, unidades e moradores em poucos cliques no painel.' },
      { title: 'Conecte o WhatsApp', description: 'Vincule o número da portaria e ative as notificações automáticas para moradores.' },
      { title: 'Pronto, já pode começar a usar!', description: 'Registre entradas, encomendas e visitantes — tudo pelo celular, em segundos.' },
    ],
    stepLabel: 'Passo',
  },

  // ── Testimonials
  testimonials: {
    badge: 'Depoimentos',
    title: 'Quem usa, aprova',
    rating: '4.9/5',
    reviews: '312 avaliações',
    items: [
      { name: 'André Mendes', role: 'Síndico — Edifício Aurora', text: 'Antes perdíamos horas com o caderno de encomendas. Agora o porteiro registra em segundos e o morador já recebe o WhatsApp. Excelente!' },
      { name: 'Patrícia Lima', role: 'Administradora — Condomínio Blue Tree', text: 'O sistema é muito intuitivo. Implementamos em dois condomínios e os moradores adoraram a notificação pelo WhatsApp quando a encomenda chega.' },
      { name: 'Roberto Souza', role: 'Porteiro — Residencial Park', text: 'Muito fácil de usar. Antes anotava tudo no papel e sempre tinham reclamações. Agora basta fotografar e registrar. Não me imagino sem esse sistema.' },
    ],
  },

  // ── Planos
  plans: {
    trialBadge: '🎉 7 dias grátis · sem cobrança hoje · cancele quando quiser',
    badge: 'Planos',
    title: 'Escolha o plano certo para o seu condomínio',
    subtitle: 'Do controle de encomendas à gestão completa. Comece com o que você precisa agora e expanda quando quiser.',
    monthly: 'Mensal',
    annual: 'Anual',
    annualDiscount: '−20%',
    annualSavings: 'R$ {{yearly}}/ano · você economiza R$ {{savings}}/ano',
    freeTrial: '🎉 Primeiros 7 dias totalmente grátis',
    ctaBtn: 'Começar 7 dias grátis →',
    items: [
      {
        id: 'encomendas', name: 'Encomendas', priceMonthly: 99, pricePerUnit: 2,
        desc: 'Acabe com o caos de encomendas na portaria — registro com foto e aviso automático ao morador no WhatsApp.',
        features: [
          'Chatbot de auto-atendimento 24h no WhatsApp',
          'Registro de encomendas com foto',
          'Aviso automático ao morador via WhatsApp',
          'QR Code para retirada segura e confirmada',
          'Relatório de pendências e retiradas',
          '3 meses de histórico',
          'Painel do síndico incluso',
          'Suporte via WhatsApp',
        ],
        badge: null, highlight: false,
      },
      {
        id: 'pro', name: 'Portaria Inteligente', priceMonthly: 79, pricePerUnit: 4,
        desc: 'Controle total de quem entra e sai: encomendas, veículos e visitantes — tudo registrado, rastreado e com histórico.',
        features: [
          'Tudo do plano Encomendas',
          'Chatbot de auto-atendimento 24h no WhatsApp',
          'Controle de acesso de veículos (Uber, delivery, prestadores)',
          'Autorização de visitantes pelo WhatsApp do morador',
          'QR Code de acesso para visitantes autorizados',
          '6 meses de histórico',
        ],
        badge: '⭐ Mais contratado', highlight: true,
      },
      {
        id: 'enterprise', name: 'Condomínio Autônomo', priceMonthly: 149, pricePerUnit: 5,
        desc: 'A gestão completa do condomínio: portaria, livro de ocorrências, reservas de áreas comuns e comunicados — tudo em um só lugar.',
        features: [
          'Tudo do plano Portaria Inteligente',
          'Chatbot de auto-atendimento 24h no WhatsApp',
          'Livro de ocorrências digital (fim do livro físico)',
          'Reserva de áreas comuns (salão, churrasqueira, academia)',
          'Comunicados e alertas para moradores',
          'Agendamento e controle de mudanças',
          '1 ano de histórico',
        ],
        badge: '🏆 Gestão Completa', highlight: false,
      },
    ],
    coupon: {
      title: 'Ganhe 10% de desconto extra',
      desc: 'Informe seu e-mail e receba um cupom exclusivo para usar no checkout.',
      placeholder: 'seu@email.com',
      btn: 'Quero o cupom',
      loadingBtn: '...',
      successTitle: 'Seu cupom está pronto!',
      successDesc: 'Use no checkout para obter 10% de desconto adicional sobre o plano.',
      copyBtn: 'Copiar',
    },
    trust: [
      'Sem fidelidade', 'Cancele quando quiser', 'Suporte via WhatsApp', 'Dados seguros na nuvem',
    ],
    securePayment: 'Pagamento 100% seguro',
    secureNote: 'Seus dados de pagamento são criptografados e processados com segurança. Nunca armazenamos dados do seu cartão.',
    toastEmailError: 'E-mail inválido',
    toastCouponSuccess: 'Cupom gerado! Use no checkout.',
    toastCouponCopied: 'Cupom copiado!',
  },

  // ── Funcionalidades detalhadas
  features: {
    badge: 'Funcionalidades',
    title: 'Cada detalhe pensado para a sua rotina',
    subtitle: 'Entenda como cada módulo funciona na prática — do registro à confirmação, tudo automatizado e rastreado.',
    visit: {
      badge: 'WhatsApp + QR Code',
      title: 'Autorização de Visita sem ligação, sem papel',
      desc: 'O porteiro informa quem chegou. O morador autoriza (ou nega) pelo WhatsApp. O visitante recebe o QR Code na hora. Tudo rastreado e arquivado.',
      steps: [
        { label: 'Porteiro registra o visitante', desc: 'Nome, documento, foto e unidade de destino — em segundos pelo painel.' },
        { label: 'Morador recebe link no WhatsApp', desc: 'Vê os dados do visitante e clica em Autorizar ou Negar — sem baixar nada.' },
        { label: 'QR Code gerado automaticamente', desc: 'O visitante apresenta o código na portaria. O porteiro escaneia e o acesso é liberado e registrado.' },
      ],
      tags: ['Histórico de acessos', 'Frequência configurável', 'Suporte a prestadores de serviço', 'Foto do visitante'],
      accessGranted: 'Acesso liberado',
    },
    vehicle: {
      badge: 'Controle Veicular',
      title: 'Sabe exatamente quem entrou — e quem ainda está dentro',
      desc: 'Registro por categoria com placa, foto e unidade de destino. O porteiro lança na entrada, confirma na saída. O síndico acompanha em tempo real.',
      categories: [
        { icon: '🚗', label: 'Apps de transporte', desc: 'Uber, 99, InDriver' },
        { icon: '📦', label: 'Delivery', desc: 'iFood, Rappi, Correios, Amazon' },
        { icon: '🔧', label: 'Prestadores de serviço', desc: 'Encanador, Eletricista, Pintores' },
        { icon: '📡', label: 'Concessionárias', desc: 'Vivo, Claro, Sabesp, Enel' },
        { icon: '📦', label: 'Mudanças', desc: 'Com agendamento e controle' },
        { icon: '👤', label: 'Visitantes', desc: 'Vinculados à unidade de destino' },
      ],
    },
    parcel: {
      badge: 'Encomendas',
      title: 'Nenhuma encomenda some ou fica esquecida',
      desc: 'O porteiro fotografa e registra a encomenda em segundos. O morador recebe aviso no WhatsApp na hora. A retirada é confirmada por QR Code ou assinatura digital.',
      steps: [
        { label: 'Porteiro fotografa e registra', desc: 'Remetente, código de rastreio e unidade destino capturados em tempo real.' },
        { label: 'Morador notificado pelo WhatsApp', desc: 'Mensagem automática com foto da encomenda e código de retirada.' },
        { label: 'Retirada confirmada por QR Code', desc: 'O morador apresenta o QR Code e o porteiro escaneia. Registro de quem retirou e quando.' },
      ],
      privacyTitle: 'Modo privacidade para encomendas sensíveis',
      privacyDesc: 'Marque uma encomenda como privada e apenas o destinatário consegue ver o conteúdo — nem outros moradores, nem o porteiro.',
    },
    doormen: {
      title: 'Porteiros por Torre',
      desc: 'Cadastre cada porteiro, defina em quais torres ele atua e controle quem está ativo. Cada operação fica vinculada ao porteiro responsável.',
      features: ['Múltiplos porteiros', 'Atribuição por torre', 'Histórico por operador', 'Ativar / desativar'],
    },
    residentApp: {
      title: 'Portal do Morador',
      desc: 'Sem download, sem cadastro. O morador abre pelo navegador do celular: vê encomendas com foto, autoriza visitas e exibe o QR Code na portaria — tudo via WhatsApp.',
      features: ['Acesso sem instalar nada', 'QR Code para retirar encomendas', 'Visitas solicitadas e aprovadas', 'Notificações em tempo real'],
    },
    notifications: {
      title: 'Notificações Automáticas',
      desc: 'Encomenda chegou? Visita autorizada? Reserva confirmada? O morador recebe no WhatsApp — sem intervenção manual da portaria.',
      features: ['Mensagens via WhatsApp', 'Lembretes automáticos', 'Badge de não lidos', 'Histórico de notificações'],
    },
    ctaBanner: 'Pronto para eliminar o papel da sua portaria?',
    ctaBannerSub: 'Mais de 500 condomínios já digitalizaram a portaria com CondoClick. Configuração em menos de 2 minutos.',
    ctaBannerBtn: 'Montar meu plano agora',
  },

  // ── FAQ
  faq: {
    badge: 'Dúvidas',
    title: 'Perguntas frequentes',
    items: [
      // Sobre o CondoClick
      { question: 'O que é o CondoClick?', answer: 'O CondoClick é uma plataforma de gestão de portaria para condomínios residenciais e comerciais. Pelo celular, o porteiro registra entradas, encomendas e visitantes — e o morador é avisado automaticamente via WhatsApp. Tudo sem papel, sem ligação, sem aplicativo para instalar.' },
      { question: 'Preciso instalar algum aplicativo?', answer: 'Não. O CondoClick funciona 100% pelo navegador do celular ou computador. O porteiro acessa por uma tela simples e o síndico pelo painel web. O morador não precisa instalar nada — ele recebe tudo via WhatsApp.' },
      { question: 'Quanto tempo leva para configurar?', answer: 'Menos de 5 minutos para criar o condomínio, cadastrar torres, unidades e o primeiro porteiro. Um assistente guiado cuida de tudo — sem planilha para importar, sem suporte técnico necessário.' },

      // Para síndicos residenciais
      { question: 'Sou síndico de prédio residencial. O CondoClick atende?', answer: 'Sim, é o perfil principal do CondoClick. Moradores recebem aviso de encomenda no WhatsApp com foto e QR Code para retirada, visitantes são autorizados pelo próprio morador, entradas de veículos ficam registradas e o síndico acompanha tudo pelo painel — sem ligação, sem papel, sem confusão.' },
      { question: 'Tenho um condomínio de casas (vila fechada). Funciona?', answer: 'Sim. Você configura o condomínio com ruas e casas em vez de torres e apartamentos. O sistema se adapta à estrutura real do seu condomínio, não o contrário.' },
      { question: 'Meu prédio tem múltiplas torres. Consigo gerenciar tudo em um lugar?', answer: 'Sim. Você cadastra cada torre com seus andares e unidades. O painel mostra tudo centralizado — histórico de entradas, encomendas, visitantes e ocorrências de todas as torres num único lugar.' },

      // Para síndicos comerciais
      { question: 'Sou síndico de prédio comercial. O CondoClick serve?', answer: 'Sim. Em prédios comerciais o controle de visitantes e entregadores é ainda mais crítico. O CondoClick registra entradas, autoriza visitantes via QR Code, controla veículos na garagem e notifica os ocupantes das salas — tudo pelo celular, sem interfone, sem papel.' },
      { question: 'Como funciona a notificação em prédios comerciais?', answer: 'Em vez de "morador", o sistema notifica o ocupante da sala ou escritório cadastrado naquela unidade. Quando chega uma encomenda ou visitante para a sala 42, o responsável recebe o aviso direto no WhatsApp — igual ao residencial, mas no contexto corporativo.' },

      // Para administradoras
      { question: 'Sou administradora e gerencio vários condomínios. Consigo centralizar?', answer: 'Sim. Cada condomínio tem seu próprio painel isolado, mas você pode acessar todos com o mesmo login de administradora. Relatórios, configurações e históricos ficam separados por condomínio, sem misturar dados.' },
      { question: 'Posso cadastrar minha equipe (coordenadores, supervisores) com acessos diferentes?', answer: 'Sim. O sistema tem perfis distintos: porteiro (acesso operacional), síndico (visão completa do condomínio) e administradora (acesso a múltiplos condomínios). Cada perfil vê e faz apenas o que é necessário para sua função.' },

      // Módulos e planos
      { question: 'Quais módulos estão disponíveis?', answer: 'Encomendas & Entregas (QR Code de retirada), Controle Veicular (placas, Uber, delivery, prestadores), Gestão de Visitantes (autorização pelo ocupante), Reservas de Espaços (salão, piscina, churrasqueira), Agendamento de Mudanças, Comunicados & Alertas e Auto-registro de Entregador.' },
      { question: 'Preciso ativar todos os módulos?', answer: 'Não. Você escolhe os módulos que fazem sentido para o seu condomínio e paga só por eles. Pode começar com encomendas e veículos e adicionar reservas e comunicados quando quiser.' },
      { question: 'Posso cancelar quando quiser?', answer: 'Sim. Sem fidelidade, sem multa. Cancele a qualquer momento — o acesso fica ativo até o fim do período pago.' },
    ],
  },

  // ── CTA Final
  ctaFinal: {
    badge: 'Condomínios residenciais e comerciais em todo o Brasil',
    title: 'Pronto para ter uma portaria',
    titleAccent: 'que funciona de verdade?',
    subtitle: 'Configure em menos de 5 minutos. Sem fidelidade, sem complicação. Comece com 7 dias grátis e veja a diferença.',
    offer: '🎉 7 dias grátis — sem precisar de cartão de crédito para começar',
    btn: 'Começar agora — é grátis',
    note: 'Pagamento seguro · Dados criptografados · Cancele quando quiser',
  },

  // ── Footer
  footer: {
    tagline: 'A portaria inteligente para condomínios modernos. Simples para o porteiro, tranquilo para o morador, poderoso para o síndico.',
    product: 'Produto',
    forWhom: 'Para quem',
    company: 'Empresa',
    links: {
      howItWorks: 'Como funciona',
      modules: 'Módulos',
      plans: 'Planos e preços',
      whyCondoClick: 'Por que o CondoClick?',
      syndics: 'Para Síndicos',
      managers: 'Para Administradoras',
      franchise: 'Seja um Franqueado',
      about: 'Sobre Nós',
      contact: 'Fale Conosco',
      support: 'Suporte Técnico',
      blog: 'Blog & Artigos',
    },
    copyright: '© {{year}} CondoClick — Todos os direitos reservados',
    privacy: 'Política de Privacidade',
    terms: 'Termos de Uso',
  },

  // ── Blog destaque (landing page)
  blogTeaser: {
    badge: 'Do nosso blog',
    title: 'Aprenda antes de decidir',
    subtitle: 'Guias práticos para síndicos, administradoras e gestores de condomínio.',
    allArticles: 'Ver todos os artigos',
    readMore: 'Ler artigo',
    featured: [
      {
        slug: 'como-controlar-encomendas-condominio',
        icon: '📦',
        category: 'Portaria & Segurança',
        title: 'Como controlar encomendas em condomínio',
        excerpt: 'Encomendas amontoadas na portaria, moradores reclamando de pacotes perdidos. Veja como criar um processo eficiente que elimina conflitos.',
        readingTime: 6,
      },
      {
        slug: 'o-caos-das-encomendas-na-portaria',
        icon: '🚨',
        category: 'Caos na Portaria',
        title: 'O caos das encomendas na portaria',
        excerpt: 'Era segunda de manhã. O porteiro encontrou 23 caixas empilhadas, nenhuma identificada, e três WhatsApps furiosos de moradores esperando.',
        readingTime: 5,
      },
      {
        slug: 'como-autorizar-visitantes-whatsapp',
        icon: '💬',
        category: 'Controle de Acesso',
        title: 'Como autorizar visitantes pelo WhatsApp',
        excerpt: 'Autorizar um visitante não deveria tomar mais de 30 segundos. Veja como o WhatsApp pode transformar o controle de acesso do seu condomínio.',
        readingTime: 5,
      },
    ],
  },

  // ── Checkout flow
  checkout: {
    backToPlans: 'Voltar aos planos',
    back: 'Voltar',
    selectedPlan: 'Plano selecionado',
    trialBadge: '🎉 7 dias grátis · sem cobrança hoje',
    perMonthAfterTrial: '/ mês após o período grátis',
    moreFeatures: 'recursos',
    summaryTitle: 'Resumo',
    sslBadge: 'Criptografia SSL de ponta a ponta',
    labelCondo: 'Condomínio',
    labelUrl: 'URL',
    labelResponsible: 'Responsável',
    labelEmail: 'E-mail',
    labelCity: 'Cidade',
    labelPlan: 'Plano',
    stepOf: 'Etapa {{step}} de 4',
    steps: ['Condomínio', 'Responsável', 'Endereço', 'Revisão'] as unknown as string[],
    condoNameLabel: 'Nome do condomínio',
    condoNamePlaceholder: 'Ex: Residencial das Flores',
    condoNameLabelMulti: 'Nome do complexo',
    condoNamePlaceholderMulti: 'Ex: Condomínio das Flores',
    subdomainLabel: 'Subdomínio (endereço do seu condomínio)',
    subdomainPlaceholder: 'flores',
    subdomainHint: 'Moradores acessarão em:',
    condoTypeLabel: 'Tipo de condomínio',
    condoTypes: {
      houses:       { label: 'Casas / Lotes',       desc: 'Condomínio horizontal, sem torres' },
      single_tower: { label: 'Torre Única',          desc: 'Um único prédio com apartamentos' },
      multi_tower:  { label: 'Múltiplas Torres',     desc: 'Dois ou mais prédios/blocos' },
    },
    condoPurposeLabel: 'Finalidade',
    condoPurposes: {
      residential:  { label: 'Residencial',  desc: 'Apartamentos, casas e lotes para moradia' },
      commercial:   { label: 'Comercial',    desc: 'Salas, lojas e espaços empresariais' },
      association:  { label: 'Associação',   desc: 'Clube, associação ou entidade sem fins lucrativos' },
    },
    towerConfigLabel: 'Configure as torres / blocos',
    towerPrefixLabel: 'Como chamar cada divisão?',
    towerPrefixTorre: 'Torre',
    towerPrefixBloco: 'Bloco',
    towerCountLabel: 'Quantas torres / blocos?',
    towerPreviewLabel: 'Serão criadas automaticamente:',
    towerPreviewHint: 'Você pode renomear cada torre no painel administrativo depois.',
    unitsLabel: 'Quantidade de unidades',
    unitsSuffix: 'unidades',
    unitsIncluded: 'inclui {{n}} unidades no plano',
    unitsExtra: 'unidades extras',
    unitsTotal: 'Total com {{n}} unidades',
    unitsPerUnitCost: '{{price}}/unidade extra/mês',
    unitsReduceNote: 'O plano cobre até {{n}} unidades.',
    unitsUpgradeNote: 'Unidades acima de {{n}} terão custo adicional.',
    labelUnits: 'Unidades',
    labelExtraUnits: 'Unidades extras',
    labelTotal: 'Total',
    fullNameLabel: 'Nome completo',
    fullNamePlaceholder: 'Nome do responsável',
    personTypeLabel: 'Tipo de pessoa',
    personIndividual: 'Pessoa Física',
    personCompany: 'Pessoa Jurídica',
    docIndividualLabel: 'CPF',
    docCompanyLabel: 'CNPJ',
    docIndividualPlaceholder: '000.000.000-00',
    docCompanyPlaceholder: '00.000.000/0000-00',
    phoneLabel: 'Telefone',
    phonePlaceholder: '(11) 99999-9999',
    passwordDivider: 'Senha de acesso admin',
    passwordLabel: 'Senha',
    passwordPlaceholder: 'Mín. 6 caracteres',
    confirmPasswordLabel: 'Confirmar senha',
    confirmPasswordPlaceholder: 'Repita a senha',
    passwordHint: 'Esta senha será usada para acessar o painel administrativo.',
    postalCodeLabel: 'CEP',
    streetLabel: 'Rua',
    streetPlaceholder: 'Preenchido pelo CEP',
    numberLabel: 'Número',
    numberPlaceholder: 'Nº',
    complementLabel: 'Complemento',
    complementPlaceholder: '(opcional)',
    neighborhoodLabel: 'Bairro',
    cityLabel: 'Cidade',
    stateLabel: 'UF',
    chargedAfter: 'Cobrado após 30 dias',
    todayPays: 'Hoje você paga',
    trialActivationTitle: 'Ativação imediata — sem cartão',
    trialActivationDesc: 'Seu condomínio será criado e ativado instantaneamente. Você receberá os dados de acesso por e-mail.',
    payTitle: 'Pagamento via InfinitePay',
    payDesc: 'Você será redirecionado para o checkout seguro da InfinitePay. Aceitamos cartão de crédito e PIX.',
    termsNote: 'Ao assinar, você concorda com os Termos de Serviço e Política de Privacidade.',
    continue: 'Continuar',
    submitTrial: 'Começar teste gratuito',
    submittingTrial: 'Criando seu condomínio...',
    submitPay: 'Pagar com InfinitePay',
    submittingPay: 'Gerando link de pagamento...',
    secure: 'Conexão segura',
    encrypted: 'Dados criptografados',
    planLabel: 'Plano {{name}}',
    perMonth: '/mês',
    errCondoName: 'Digite o nome do condomínio',
    errSlugMin: 'Subdomínio deve ter no mínimo 3 caracteres',
    errCondoPurpose: 'Selecione a finalidade do condomínio',
    errCondoType: 'Selecione o tipo de condomínio',
    errAdminName: 'Digite o nome do responsável',
    errEmail: 'E-mail inválido',
    errDocIndividual: 'CPF inválido',
    errDocCompany: 'CNPJ inválido',
    errPhone: 'Telefone inválido',
    errPasswordMin: 'Senha deve ter no mínimo 6 caracteres',
    errPasswordMatch: 'As senhas não coincidem',
    errPostalCode: 'Digite o CEP',
    errStreet: 'Busque o CEP para preencher o endereço',
    errSlugTaken: 'Subdomínio já em uso. Escolha outro.',
    errGeneric: 'Erro no checkout',
    toastCreated: 'Condomínio criado com sucesso! 🎉',
    toastRedirecting: 'Redirecionando para o pagamento...',
    emailSentTitle: 'Verifique seu e-mail 📧',
    emailSentDesc: 'Enviamos um link de confirmação para <strong>{{email}}</strong>. Clique no link para concluir o cadastro.',
    emailSentCheck: 'Verifique sua caixa de entrada (e o spam)',
    emailResendBtn: 'Reenviar e-mail',
    emailResending: 'Enviando...',
    emailResent: 'E-mail reenviado com sucesso!',
    emailSentExpire: 'O link expira em 24 horas.',
    emailSentBack: 'Alterar dados',
    toastEmailSent: 'E-mail de confirmação enviado! Verifique sua caixa de entrada.',
  },

  // ── Mobile bottom bar
  mobileBar: {
    from: 'A partir de',
    price: '{{symbol}} 59',
    perMonth: '/mês',
    btn: 'Assinar agora',
  },

  // ── Módulos catalog (wizard)
  modulesCatalog: [
    { id: 'encomendas', label: 'Encomendas & Entregas', desc: 'Registro com foto, notificação WhatsApp e retirada por QR Code' },
    { id: 'veiculos', label: 'Controle Veicular', desc: 'Registro de placas, visitantes, Uber, delivery e prestadores' },
    { id: 'visitantes', label: 'Gestão de Visitantes', desc: 'Autorização pelo morador via WhatsApp + QR Code de acesso' },
    { id: 'reservas', label: 'Reservas de Espaços', desc: 'Salão, churrasqueira, piscina — reserva pelo celular' },
    { id: 'mudancas', label: 'Agendamento de Mudanças', desc: 'Aprovação do síndico, QR Code para transportadora' },
    { id: 'comunicados', label: 'Comunicados & Alertas', desc: 'Avisos e documentos para moradores via WhatsApp' },
    { id: 'entregador', label: 'Auto-registro de Entregador', desc: 'QR Code fixo na portaria — entregador registra sozinho' },
  ],
} as const;

export type LandingTranslations = typeof ptBR;
export default ptBR;
